import * as Yup from 'yup';

export interface CommentValues {
  message: string;
}

export const model = {
  message: {
    name: 'message',
    inputType: 'textarea',
    placeholder: 'What do you think...',
  },
  screenshot: {
    name: 'screenshot',
    type: 'file',
    placeholder: 'Screenshot...',
  },
};

export const validationSchema = Yup.object().shape({
  [model.message.name]: Yup.string().required('Required'),
});

export const initialValues = {
  [model.message.name]: '',
};
